import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { ConfigService } from "../config/config.service";
import { UtilsService } from "../utils/utils.service";
import { CustomerModel } from "src/app/models/customer-model";
import { UserSessionService } from "../user-session/user-session.service";

@Injectable({
  providedIn: "root",
})

export class LobbyService {

  public waitingGameData = null;
  public pendingBonusCode = null;
  public waitingDialogPage = null;
  public timeOnline: any;
  private isIAB: boolean = false;
  public subPage;
  private optInId = null;
  public currentLoginTime: Date;
  private gamePopoverOpen: boolean = false;
  public gameSessionToken: any;
  public customer: CustomerModel;
  public galleryImagePath = this.config.getConfig().CDN_BASEURL + '/assets/social/games/';  //main image path

  constructor(
    private utils: UtilsService,
    private config: ConfigService,
    private userSession:UserSessionService,
    private http: HttpClient,
  ) {
    this.userSession.getCustomer().subscribe(
      (customer) => {
        this.customer = customer;
      }
    );
  }

  clearWaitingGameData() {
    this.waitingGameData = null;
  }

  // Setters implementation pending
  isIABApp(): boolean {
    return this.isIAB;
  }

  getCustomerOptInId() {
    return this.optInId;
  }

  public isVerticalEnabled = (verticalCode) => {
    let isIOS = this.utils.isIosApp();
    let productVerticals = {
      sports: true,
      casino: true,
      home: true,
    };
    return verticalCode in productVerticals
      ? productVerticals[verticalCode]
      : true;
  };

  setCustomerOptInId(id) {
    this.optInId = id;
  }

  getWaitingGameData() {
    return this.waitingGameData;
  }

  getPendingBonusCodes() {
    return this.pendingBonusCode;
  }

  getWaitingDialogPage() {
    return this.waitingDialogPage;
  }

  setWaitingGameData(data) {
    this.waitingGameData = data;
  }

  setPendingBonusCodes(data) {
    this.pendingBonusCode = data;
  }

  setWaitingDialogPage(page) {
    this.waitingDialogPage = page;
  }

  clearWaitingDialogPage() {
    this.waitingDialogPage = null;
  }
  setGamePopoverState(state: boolean) {
    this.gamePopoverOpen = state;
  }

  setCurrentLoginTime(currentLoginTime: Date) {
    this.currentLoginTime = currentLoginTime;
  }

  getCurrentLoginTime() {
    return this.currentLoginTime;
  }

  setGameSessionID(game_token) {
    this.gameSessionToken = game_token;
  }

  getGameSessionID() {
    return this.gameSessionToken;
  }

  clearGameSessionID() {
    this.gameSessionToken = null;
  }

}
